import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/pages/00-Welcome'
import Auth from '@/pages/00-Auth'
import Instructions from '@/pages/01-Instructions'
import Play from '@/pages/02-Play'
import GameOver from '@/pages/03-GameOver'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/calcucil/play/',
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth
    },
    {
      path: '/instructions',
      name: 'Instructions',
      component: Instructions
    },
    {
      path: '/playing',
      name: 'Play',
      component: Play
    },
    {
      path: '/game-over',
      name: 'GameOver',
      component: GameOver
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js